import { client } from '@efex-services/config';
import {
  LendingService,
  LendingServiceRequest,
  PayLendingServiceRequest,
  PayLendingServiceResponse,
  SearchLendingServiceRequest,
} from '../types';

const getLendings = ({
  enterpriseId,
}: LendingServiceRequest): Promise<LendingService> =>
  client.get(`lending/${enterpriseId}`);

const searchLendings = ({
  enterpriseId,
  searchParams,
}: SearchLendingServiceRequest): Promise<LendingService> =>
  client.get(`lending/${enterpriseId}?search=${searchParams}`);

const payLending = ({
  enterpriseId,
  data,
}: PayLendingServiceRequest): Promise<PayLendingServiceResponse> =>
  client.post(`lending/${enterpriseId}`, data);

const lendingSvc = {
  getLendings,
  searchLendings,
  payLending,
};

export default lendingSvc;
